import "./TemplateHierarchy.less";
import * as React from "react";
import { IBaseProps } from "lib/data/interfaces";
import { TransitionRoute } from "components/general/TransitionRoute";
import { RouteComponentProps } from "react-router-dom";
import { ComponentTemplate } from "lib/data/model";
import { RequirementItem } from "lib/data/modelItem";
import { SectionTemplateSelector } from "../components/TemplateRequirementSelector/SectionTemplateSelector";
import './TemplateHierarchy.less';
import { SectionTemplateTitle } from "./components/SectionTemplateTitle";
interface ITemplateHierarchyDirectoryProps extends IBaseProps, RouteComponentProps<any> {

}

interface ITemplateHierarchyDirectoryState {
	templateRequirementList: RequirementItem<ComponentTemplate>[],
	templateSelectorData: ComponentTemplate[],
	visibleSection: "template-requirement-selector" | "generic-template-selector" | "requirement-configuration" | "requirement-configuration",
	loading: boolean;
	itemHierarchy: any[];
}


export class TemplateHierarchyDirectory extends React.Component<ITemplateHierarchyDirectoryProps, ITemplateHierarchyDirectoryState> {

	public static readonly BasePath: string = "/admin/templatehierarchy";

	public constructor(props: any) {

		super(props);

		this.state = {
			visibleSection: "template-requirement-selector",
			templateSelectorData: [],
			templateRequirementList: [],
			itemHierarchy: [],
			loading: true,
		};
	}
	public activeClassName = "active-template-card";

	public render() {

		// Render Normally
		return (
			// <Secure redirectOnDenial="/">
			<div>
				<div className="template-hierarchy">
					<TransitionRoute on={this.state.visibleSection} case={"template-requirement-selector"}>
						<div>
							<SectionTemplateTitle noEdit={true} sectionTemplateName={"Directory"} />
							<SectionTemplateSelector />
						</div>
					</TransitionRoute>
				</div>
			</div>
			// </Secure>
		);
	}

	//private onSideBarButtonClick = () => {

	//}
}
